import React from "react";
import "./utility_components.scss";
import { If } from "react-extras";

export const checkedState = "checkedState";
export const defaultCheckedState = "defaultCheckedState";
export const notCheckedState = "notCheckedState";

export const TriStateCheckmark = props => {
  return (
    <span className={"tri-state-checkmark"}>
      <If condition={props.state === defaultCheckedState}>
        <span className={"default-checked"}>-</span>
      </If>
      <CheckMark
        checked={props.state === checkedState}
        onClick={e => {
          props.onClick && props.onClick(e);
        }}
      />
    </span>
  );
};

export const CheckMark = ({ checked, onClick }) => (
  <input
    type="checkbox"
    className={"tri-state-checkmark--input"}
    checked={checked}
    onClick={onClick}
  />
);
